import { Injectable } from '@angular/core';
import { Store } from 'src/app/core/services/store.service';
import { HttpClient } from '@angular/common/http';
import { IComponentSliderConfig, ISlidersConfig } from '../models/slider.model';

@Injectable({
  providedIn: 'root',
})
export class SliderStoreService extends Store<ISlidersConfig[]> {
  private configUrl = 'assets/slider.config.json';

  constructor(private http: HttpClient) {
    super(null);
    this.http.get<ISlidersConfig[]>(this.configUrl).subscribe(value => {
      this.setState(value);
    });
  }

  public getState() {
    return this.state$;
  }
}

export const OnboardingSliderConfig: IComponentSliderConfig = {
  style: {
    display: 'flex',
    'flex-direction': 'column',
    'justify-content': 'space-around',
    width: '100%',
    height: '350px',
    'text-align': 'center',
  },
  imgStyle: {
    'max-height': '200px',
    width: 'auto',
    height: 'auto',
    'max-width': '100%',
    'object-fit': 'contain',
  },
  titleStyle: {
    position: 'static',
    color: 'black',
  },
  subtitleStyle: {
    position: 'static',
    f4color: 'black',
  },
  buttonsStyle: {
    position: 'static',
    'justify-content': 'center',
    transform: 'translate(0, 0)',
  },
  interval: 15,
  items: [
    {
      id: 1,
      title: 'Zobacz jakie to proste!',
      subtitle: 'Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. ' +
        'Morbi varius neque eu ornare varius. Fusce auctor odio a tortor gravida dictum.',
      imgUrl: '/assets/images/mobile-notice-bg.jpg',
    },
    {
      id: 2,
      title: 'Zobacz jakie to proste!',
      subtitle: 'Płać później za\nswoje ubezpieczenia.',
      imgUrl: '/assets/images/payka_pink_square.jpg',
    },
    {
      id: 3,
      title: 'Zobacz jakie to proste!',
      subtitle: 'Płać później za\nswoje ubezpieczenia.',
      imgUrl: '/assets/images/mobile-notice-bg.jpg',
    },
  ],
};
